import { motion } from "framer-motion";
import Icon from "./Icon";
import screenshot from "../assets/screenshot.jpeg";

function BentoGrid() {
  return (
    <section className="py-32 px-8 bg-surface scroll-mt-20" id="benefits">
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-6">
        {/* Hyper-local Precision - Large */}
        <motion.div
          className="md:col-span-8 bg-primary-container/5 rounded-xl p-10 flex flex-col justify-between group overflow-hidden relative"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
        >
          <div className="relative z-10">
            <h3 className="font-headline text-3xl font-bold mb-4">Hyper-local Precision</h3>
            <p className="text-on-surface-variant max-w-md">
              Our algorithm maps favors that suit your walking, biking or driving radius. True community is about who is next door.
            </p>
          </div>
          <div className="absolute -right-10 -bottom-10 w-64 h-64 bg-primary-container/20 rounded-full group-hover:scale-125 transition-transform duration-700"></div>
          <Icon name="my_location" className="text-8xl absolute -right-4 bottom-4 text-primary-container/10 group-hover:rotate-12 transition-transform" />
        </motion.div>

        {/* Real-time Matching */}
        <motion.div
          className="md:col-span-4 glass-card border border-outline-variant/20 rounded-xl p-10 shadow-sm"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <div className="w-12 h-12 rounded-full bg-secondary-container/30 flex items-center justify-center text-secondary mb-6">
            <Icon name="bolt" />
          </div>
          <h3 className="font-headline text-2xl font-bold mb-4">Real-time Matching</h3>
          <p className="text-on-surface-variant">
            Instant notifications and rapid response times. Matching is as fast as possible.
          </p>
        </motion.div>

        {/* Structured Workflow */}
        <motion.div
          className="md:col-span-4 glass-card border border-outline-variant/20 rounded-xl p-10 shadow-sm"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="w-12 h-12 rounded-full bg-tertiary-container/20 flex items-center justify-center text-tertiary mb-6">
            <Icon name="architecture" />
          </div>
          <h3 className="font-headline text-2xl font-bold mb-4">Structured Workflow</h3>
          <p className="text-on-surface-variant">
            No vague requests. Every favor follows a predefined structure for maximum clarity.
          </p>
        </motion.div>

        {/* Pristine Quality - Large */}
        <motion.div
          className="md:col-span-8 bg-surface-container rounded-xl p-10 flex flex-col md:flex-row gap-8 items-center justify-between"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <div>
            <h3 className="font-headline text-3xl font-bold mb-4">Pristine Quality</h3>
            <p className="text-on-surface-variant max-w-md">
              Every interaction is designed to be frictionless. From the UI to the final 'thank you'.
            </p>
            <button
              onClick={() => document.getElementById("how-it-works").scrollIntoView({ behavior: "smooth" })}
              className="mt-6 font-bold text-primary flex items-center gap-2 hover:gap-4 transition-all"
            >
              Learn more <Icon name="arrow_forward" />
            </button>
          </div>
          <div className="w-full md:w-48 aspect-square rounded-2xl overflow-hidden shadow-2xl rotate-3">
            <img
              className="w-full h-full object-cover"
              alt="Abstract 3D flowing shapes"
              src={screenshot}
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default BentoGrid;
